
    import { Component, Vue } from 'vue-property-decorator';
    import Layout from '@/components/layout/Layout.vue';
    import Table from '@/components/table/Table.vue';
    import Filters from '@/components/table/Filters.vue';
    import {ApiRepository} from '@/api';


    @Component({
        components: {
            Layout,
            Table,
            Filters,
        },
    })
    export default class PartnerApplication extends Vue {
        private keys = {
            id: '#',
            name: 'Meno',
            surname: 'Priezvisko',
            street: 'Ulica',
            streetNumber: 'Číslo ulice',
            city: 'Mesto',
            status: 'Status',
            'card.number': 'Číslo karty',
            createdAt: 'Dátum vytvorenia'
        };

        private filterKeys = {
            id: '#',
            name: 'Meno',
            surname: 'Priezvisko',
            street: 'Ulica',
            streetNumber: 'Číslo ulice',
            city: 'Mesto',
            status: 'Status',
            createdAt: 'Dátum vytvorenia'
        };

        // sortovani podla atributu podobjektu nie je podporovane v typeorm, potrebny redizajn responseGenerator v API
        private excludedSorders = ['card.number'];

        private selects = {
            status: [
                'new',
                'approved',
                'denied',
                'cancelled',
                'anonymize'
            ],
        };
        private data: any = [];

        private filters = '';
        private showSpinner = false;

        // paging
        private pager = {
            count: 0,
            take: 0,
            page: 0,
            totalCount: 0
        };

        // sorting
        private key = '';
        private sort = '';

        private links = [
            {
                url: '/ziadosti/:param:',
                image: require('@/assets/image/edit.svg'),
            },
        ];

        // toto funguje tak, ze ak je v stlpci s nazvom 'status' hodnota 'new', tak sa tam priradia prislusne classy
        private customColumnClass = {
            'status': {
                'new': {
                    'text-blue': true,
                    'font-bold': true
                },
                'approved': {
                    'text-green': true,
                    'font-bold': true
                },
                'denied': {
                    'text-red': true,
                    'font-bold': true
                },
                'cancelled': {
                    'text-gray': true,
                    'font-bold': true
                }
            }
        };

        public async mounted() {
            await this.sendRequest();
        }

        private async changePage(page: Number) {
            await this.changeOptions({
                key: this.key || 'id',
                page: page
            });
        }

        private async changeOptions(data: any) {
            this.data = await ApiRepository.getPartnerApplications(this.$store.getters.partner, {
                sort: data.key,
                order: data.sort ? 'ASC' : 'DESC',
                filters: this.filters,
            });

            this.pager.page = data.page || this.pager.page;
            this.key = data.key;
            this.sort = data.sort;

            await this.sendRequest({
                page: this.pager.page,
                sort: this.key,
                order: this.sort ? 'ASC' : 'DESC',
                filters: this.filters
            });
        }

        private async setFilter(filters: any) {
            let strFilter: any = [];

            if (filters) {
                Object.keys(filters).forEach((key: string) => {
                    strFilter.push(key + ':' + filters[key]);
                });
            }
            strFilter = strFilter.join(',');

            this.filters = strFilter;

            await this.sendRequest({
                sort: this.key || 'id',
                order: this.sort ? 'ASC' : 'DESC',
                filters: strFilter
            });
        }

        private async sendRequest(params: object = {}) {
            this.showSpinner = true;
            let response = await ApiRepository.getPartnerApplications(this.$store.getters.partner, params);

            this.data = response.data;
            this.pager = {
                count: response.count,
                take: response.take,
                page: response.page,
                totalCount: response.totalCount
            };

            this.showSpinner = false;
        }
    }
